import { ReactComponent as MoneyBackIcon } from './Money-back-guarantee.svg';
import { ReactComponent as NoHiddenFeesIcon } from './no-hidden-fees.svg';
import { ReactComponent as SupportIcon } from './24-7-support.svg';

export default {
	heading: 'We\'ve got your back.',
	items: [
		{
			title: 'Search skills',
			description:
				'Find and keep good people with an easy workspace that gets results.',
			icon: MoneyBackIcon,
			link: 'https://www.69work.com/marketplace/skills',
			linkLabel: 'All skills',
			internalLink: false,
		},
		{
			title: 'Approve job',
			description:
				'Funds held with PayPal or Amazon Pay until the job is done on time.',
			icon: NoHiddenFeesIcon,
			link: '/legal/marketplace-terms/',
			linkLabel: 'Ground rules',
			internalLink: true,
		},
		{
			title: 'PayPal & VISA® payouts',
			description:
				'We credit your Seller\'s VISA® debit or credit card, PayPal, Venmo, or bank.',
			icon: SupportIcon,
			link: '/marketplace/settings/payouts',
			linkLabel: 'More info',
			internalLink: true,
		},
	],
};

